import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

export default class Commons {
    successes: Array<any> = [];
    errors: Array<any> = [];
    toastr: ToastrService;
	translate: TranslateService;

	loadScripts() {
		const dynamicScripts = [
			environment.casBaseUrl + 'js/components.js'
		];
		const currentScripts = Array.from(document.scripts);
		dynamicScripts.forEach((url) => {
			if (currentScripts.some((script) => {
				return script.getAttribute('src') === url;
			})) { // load any script at most once
				return;
			}
			const node = document.createElement('script');
			node.src = url;
			node.type = 'text/javascript';
			node.async = false;
			node.charset = 'utf-8';
			document.getElementsByTagName('head')[0].appendChild(node);
		});
	  }

    constructor(toastr, translate) {
        this.toastr = toastr;
		this.translate = translate
		this.loadScripts();
    }

    save() {
        console.error('Save is not implemented!')
    }

    clearNotifications() {
        this.errors = [];
        this.clearSuccesses();
        return this;
    }

    clearSuccesses() {
        this.successes = [];
        return this;
    }

    addError(error: string) {
        if (this.errors.indexOf(error) === -1) {
            this.errors.push(error)
        }
        this.translate.getTranslation(this.translate.currentLang).subscribe((translation) => {
            this.toastr.error(translation[error] ? translation[error] : error)
        }, err => this.errorHandler(err));
    }

    addSuccess(success: string) {
        this.successes.push(success);
        this.translate.getTranslation(this.translate.currentLang).subscribe((translation) => {
            this.toastr.success(translation[success] ? translation[success] : success)
        }, err => this.errorHandler(err));
    }

    errorHandler(err) {
        try {
            const errParsed = JSON.parse(err.error);
            if (errParsed && (errParsed.message === 'Signature does not mach, probabaly logout - login needed' ||
                errParsed.message === 'Signature does not mach, probably logout - login needed' ||
                errParsed.message === 'Token invalid. Relogin needed' ||
                errParsed.message === 'This token has been invalidated')) {
                window.location.href = '/login';
            } else {
                if (!errParsed) {
                    this.addError("Technical problem");
                } else if (errParsed.message){
                    this.addError(errParsed.message);
                } else {
                    this.addError(errParsed.error || "Technical problem");
                }
            }
        } catch (e) {
            if (err._body) {
				this.addError(err._body);
				return;
            } else if (err.status === 0) {
				this.addError('Backend server down or no internet connection');
				return;
			}
			try {
				const error = JSON.parse(err.error);
				this.addError(error.messages || error.error);
			} catch (e) {
				this.addError("Technical problem");
			}
		}
    }
}
